// ? 限制输入框只能输11位手机号
export function limitPhone(val) {
  let tempValue = val.replace(/[^0-9]/gi, '')
  if (tempValue.length > 11) {
    return tempValue.split('').join('').slice(0, 11)
  }
  return tempValue
}
